'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePassword = void 0;
var arrays_1 = require("./arrays");
var generatePassword = function (length) {
    if (length === void 0) { length = 10; }
    if (length < 4) {
        throw new Error('stringLength must be at least 4');
    }
    var numberChars = '0123456789';
    var upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var lowerChars = 'abcdefghijklmnopqrstuvwxyz';
    var specialChars = '!"#$%&()*+,-./:;<=>?@[]^_`{|}~';
    var dictionary = [numberChars, upperChars, lowerChars, specialChars];
    var result = [];
    for (var i = 0; i < length; i++) {
        var index = i % dictionary.length;
        result.push(dictionary[index][Math.floor(Math.random() * dictionary[index].length)]);
    }
    return arrays_1.shuffle(result).join('');
};
exports.generatePassword = generatePassword;
